import { isSSR } from './isSSR.js';
import { platform } from './platform.js';

function fixSafariActive() {
  if (!isSSR() && platform === 'iOS') {
    // Fix for mobile safari won't trigger :active pseudo state
    // https://stackoverflow.com/questions/3885018/active-pseudo-class-doesnt-work-in-mobile-safari
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    document.addEventListener('touchstart', function () {}, false);
  }
}

export { fixSafariActive };
//# sourceMappingURL=fixSafariActive.js.map
